import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { Search } from '@mui/icons-material';
import { ProductVm } from 'api/catalog/product.vm';
import { getProducts } from 'api/catalog/get-products';
import { useSnackbar } from 'hooks/use-snackbar';

interface ProductSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  onProductSelect: (product: ProductVm) => void;
}

const ProductSelectionDialog = ({ open, onClose, onProductSelect }: ProductSelectionDialogProps) => {
  const [availableProducts, setAvailableProducts] = useState<ProductVm[]>([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const snackbar = useSnackbar();
  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleSearch = async () => {
    setSearchLoading(true);
    getProducts('', searchTerm, {
      success: (response) => {
        setAvailableProducts(response.objects);
        setSearchLoading(false);
      },
      error: (err) => {
        console.error('Falha ao pesquisar produtos:', err);
        snackbar.show('Falha ao pesquisar produtos', null, 'error');
        setSearchLoading(false);
      },
    });
  };

  useEffect(() => {
    if (open) {
      handleSearch();
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Selecionar Produto</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Pesquisar produtos por SKU ou nome"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ mr: 2 }}
            inputRef={inputRef}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />
          <Button variant="contained" sx={{ height: '100%' }} startIcon={<Search />} onClick={handleSearch} disabled={searchLoading}>
            Pesquisar
          </Button>
        </Box>

        {searchLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>SKU</TableCell>
                  <TableCell>Nome</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {availableProducts.map((product) => (
                  <TableRow key={product.id} hover onClick={() => onProductSelect(product)} sx={{ cursor: 'pointer' }}>
                    <TableCell>{product.sku}</TableCell>
                    <TableCell>{product.name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductSelectionDialog;
